<template>
  <div class="checkout">
    <div class="wrapper">
      <h2>{{ trans.text['store-redirect'].title }}</h2>
      <div class="nav-store-wrap">
        <a :href="appStore" class="appStore" target="_blank">
          <img alt="app-store" src="/assets/images/app_store.svg">
        </a>
        <a :href="googlePlay" class="googlePlay" target="_blank">
          <img alt="google-play" src="/assets/images/google-play.svg">
        </a>
      </div>
      <p class="text">{{ trans.text['store-redirect'].message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['lang', 'trans', 'appStore', 'googlePlay'],
  name: "StoreRedirect",
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.checkout {
  width: 100%;
  max-width: 100%;
}

h2, .h2 {
  font-weight: bold;
  font-size: 36px;
  line-height: 37px;
  color: #000000;
  margin: 0;
  text-align: center;
}

.text {
  font-size: 21px;
  line-height: 32px;
  color: #A3A3A3;
  text-align: center;
  max-width: 589px;
  margin: 0 auto;

  &:last-child {
    margin-bottom: 120px;
  }
}

.nav-store-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 100px 0;

  .appStore, .googlePlay {
    margin: 0 38px;
    display: block;
    font-size: 0;

    img {
      max-width: 100%;
    }
  }

  .appStore {
    width: 318px;
    object-fit: contain;
  }

  .googlePlay {
    width: 364px;
    object-fit: contain;
  }
}

@media (max-width: 991px) {
  .nav-store-wrap {
    .appStore, .googlePlay {
      margin: 0 16px;
      display: block;
      font-size: 0;
    }

    .appStore {
      width: 211px;
    }

    .googlePlay {
      width: 236px;
    }
  }
}

@media (max-width: 767px) {
  h2, .h2 {
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #232323;
  }
  .nav-store-wrap {
    margin: 36px 0 58px;
  }
  .text {
    font-size: 14px;
    line-height: 21px;

    &:last-child {
      margin-bottom: 90px;
    }
  }
}

@media (max-width: 575px) {
  h2, .h2 {
    max-width: 171px;
    margin: 0 auto;
  }
  .nav-store-wrap {
    flex-direction: column;

    .appStore {
      margin-bottom: 25px;
      max-width: 100%;
    }

    .googlePlay {
      width: 211px;
      max-width: 100%;
    }
  }
}
</style>
